<template>
  <DatatableReportV3
    id="members-by-address-table"
    title="By Address"
    download-url="/reports/members_by_address"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { customerClassificationColumns } from "@/lib/customerTypes";

import Badge from "@/components/Badge.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // The default sort is by position, so it moves with the classification
    // columns to stay on the same column.
    const classificationColumns = customerClassificationColumns();

    return {
      config: {
        responsive: true,
        order: [[classificationColumns.length, "asc"]],
        columns: [
          ...classificationColumns,
          { data: "customer", responsivePriority: 1 },
          {
            data: "service_address",
            title: "Service Address",
            responsivePriority: 2
          },
          { data: "zipcode", title: "Zip Code", responsivePriority: 18 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 17
          },
          {
            data: "program",
            filterName: "program",
            searchable: false,
            responsivePriority: 3
          },
          {
            data: "program_status",
            title: "Program Status",
            filterName: "membership_program_status",
            orderable: false,
            searchable: false,
            responsivePriority: 4
          },
          {
            data: "payment_method_on_file",
            responsivePriority: 8,
            title: "Payment Method on File",
            filterName: "payment_method_on_file",
            orderable: false,
            searchable: false
          },
          {
            data: "membership_status",
            responsivePriority: 5,
            title: "Member Status",
            filterName: "membership_status",
            searchable: false
          },
          {
            data: "days_to_renewal",
            responsivePriority: 6,
            title: "Days to Renewal",
            searchable: false
          },
          {
            data: "available_services",
            responsivePriority: 9,
            title: "Available Services",
            filterName: "available_services",
            orderable: false,
            searchable: false
          },
          {
            data: "renewal_type",
            responsivePriority: 13,
            title: "Renewal Type",
            filterName: "renewal_type",
            orderable: false,
            searchable: false
          },
          {
            data: "since",
            filterName: "starts_on",
            searchable: false,
            responsivePriority: 14
          },
          {
            data: "next_billing_date",
            responsivePriority: 7,
            title: "Next Billing Date",
            filterName: "renews_at",
            searchable: false
          },
          {
            data: "ends_on",
            title: "Ends On",
            searchable: false,
            responsivePriority: 12
          },
          { data: "customer_email", title: "Email", responsivePriority: 16 },
          { data: "customer_phone", title: "Phone", responsivePriority: 11 },
          {
            data: "tags",
            title: "Tags",
            orderable: false,
            searchable: false,
            responsivePriority: 15
          },
          {
            data: "covered_systems",
            responsivePriority: 10,
            title: "Covered Systems",
            filterName: "covered_systems",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "tag-list-vue",
            component: TagList
          },
          {
            rootId: "badge-vue",
            component: Badge
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "By Address" });
  }
};
</script>

<style lang="scss" scoped></style>
